const fallbackFont = '"Helvetica Neue", Helvetica,Arial, sans-serif';

const fontStacks = Object.freeze({
  webfonts: [
    [
      'Merriweather',
      [ '/static/fonts/merriweatherLatin-300.woff2', '/static/fonts/merriweatherLatin-300.woff', ],
      { fontWeight: 200, fontDisplay: 'fallback', },
    ],
    [
      'Merriweather',
      [
        '/static/fonts/merriweatherLatin-regular.woff2',
        '/static/fonts/merriweatherLatin-regular.woff',
      ],
      { fontWeight: 400, fontDisplay: 'fallback', },
    ],
    [
      'Merriweather',
      [ '/static/fonts/merriweatherLatin-700.woff2', '/static/fonts/merriweatherLatin-700.woff', ],
      { fontWeight: 700, fontDisplay: 'fallback', },
    ],
  ],
  base: `"Merriweather",${fallbackFont}`,
  alt: fallbackFont,
  commercial: fallbackFont,
});

export default fontStacks;
